module.exports = __webpack_public_path__ + "img/2.321e5741.png";